import Image from "next/image";
import React, { useEffect, useState } from "react";

const FAQItem = ({ faq, onClick, isOpen }) => {
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    // Only set the HTML content on the client side
    setHtmlContent(faq.icerik || "");
  }, [faq.icerik]);

  return (
    <div
      className={`border rounded-md py-3 md:px-5 px-3 transition-all duration-300 bg-white border-gray-200`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between cursor-pointer">
        <h3
          className={`sm:text-lg sm:leading-5 text-sm font-medium ${
            isOpen ? "text-themeSecondColor" : "text-themeBlack"
          }`}
        >
          {faq.baslik}
        </h3>
        <Image
          src={isOpen ? "/icons/topAccordion.svg" : "/icons/downAccordion.svg"}
          width={20}
          height={20}
          alt="toggle arrow"
          className={`transition-transform duration-300`}
        />
      </div>
      {htmlContent && (
        <div
          className={`overflow-hidden ${
            isOpen ? "h-full mt-2.5" : "h-0"
          } text-themeBlack text-opacity-50 text-sm`}
        >
          <p dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
      )}
    </div>
  );
};

export default FAQItem;
